import React from 'react'
import AddPurposeForm from '../../../component/form/master/purpose/AddPurposeForm'

export default function AddPurpose() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddPurposeForm />
                    </div>
                </div>
            </div>
        </>
    )
}


